import React, { useState, createContext, useEffect } from 'react';
import MainSection from './MainFrame';
import { HomeWorkspaceTiles } from '../../Types/HomePageInterface'
import { useGetMyWorkspaceMutation } from '../../Redux/Home/HomeWorkspaceSlice'
import NoWorkspacesMessage from './NoWorkspace'
import { Header } from '../../GenericComponents/PageFrame/Header';
import { Skeleton } from '../../GenericComponents/Skeleton';
import WorkspaceRegion from './WorkSpaceRegion';
import { useDispatch, useSelector } from "react-redux";
import { RootState, getCurrentUserData } from '../../Redux/store';
import { useTitleContext } from "../../Hooks/useTitleContext";
import Overlay from './Overlay';


export const HomeContext = createContext<any>(null);

const HomeBase = () => {
  const [DetachThisWorkspaceDialog, setDetachThisWorkspaceDialog] = useState<boolean>(false);
  const [EditThisWorkspaceDialog, setEditThisWorkspaceDialog] = useState<boolean>(false);
  const [ShareThisWorkspaceDialog, setShareThisWorkspaceDialog] = useState<boolean>(false);
  const [DeleteThisWorkspaceDialog, setDeleteThisWorkspaceDialog] = useState<boolean>(false);
  const [WorkspaceIdforDialog, setWorkspaceIdforDialog] = useState<number>(0); // ! CAUTION : THIS ID IS INTENDED TO BE USED FOR DIALOGS ONLY, IF YOU USE THEM MAKE SURE TO TEST THE STATE PROPERLY -> FILES THAT COULD BE AFFECCTED ALL COMPONENTS COVERED IN HomeBase
  const [editCallback, SeteditCallback] = useState(() => () => { });
  const [triggerPrivacyLock, setTriggerPrivacyLock] = useState<boolean>(false);
  const [DialogMsg, setDialogMsg] = useState<string>("Use this for all dialogs can be used commonly")
  const [rgborname_color, setrgborname_color] = useState<string | null>()
  const [WorkSpaceDetails, SetWorkSpaceDetails] = useState<HomeWorkspaceTiles>()

  const { setTitle } = useTitleContext();
  setTitle("Home");

  const dispatch = useDispatch();
  const [currentUsersData, setCurrentUsersData] = useState<any>({
    UserFavWorkspace: "",
    privileges: []
  });
  const contextValue = {
    DetachThisWorkspaceDialog,
    setDetachThisWorkspaceDialog,
    EditThisWorkspaceDialog,
    setEditThisWorkspaceDialog,
    ShareThisWorkspaceDialog,
    setShareThisWorkspaceDialog,
    DeleteThisWorkspaceDialog,
    setDeleteThisWorkspaceDialog,
    WorkspaceIdforDialog,
    setWorkspaceIdforDialog,
    DialogMsg,
    setDialogMsg,
    rgborname_color,
    setrgborname_color,
    WorkSpaceDetails,
    SetWorkSpaceDetails,
    currentUsersData,
    editCallback,
    SeteditCallback,
    triggerPrivacyLock, 
    setTriggerPrivacyLock
  };

  const [workspaces, setWorkspaces] = useState<HomeWorkspaceTiles[]>([]);
  const [GetMyWorkspace, { data: configData, error: configError, isLoading: configLoading }] = useGetMyWorkspaceMutation();

  const [isLoading, setIsloading] = useState(true);
  useEffect(() => {
    setIsloading(true);
    const fetchData = async () => {
      try {
        // Fetch workspaces using the API hook
        const FetchedWorkspaces = await GetMyWorkspace().unwrap();
        if (FetchedWorkspaces.length != 0) {
          // setWorkspaces(FetchedWorkspaces);
          const sortedHomeWorkspaceTiles = [...FetchedWorkspaces].sort((a, b) => {
            if (a.WorkspaceId === 0 && a.Name.toLowerCase().includes('favorites')) {
              return -1;
            }
            if (b.WorkspaceId === 0 && b.Name.toLowerCase().includes('favorites')) {
              return 1;
            }
            return 0;
          });
          // setSortedWorkspaces(sortedHomeWorkspaceTiles)
          setWorkspaces(sortedHomeWorkspaceTiles);
          setIsloading(false);
        }
        else {
          setIsloading(false);
        }
      } catch (err) {
        console.error('Failed to fetch workspaces:', err);
      }
    };
    fetchData();
  }, []);



  return (
    <>
      {isLoading ? (
        <div id="dashboard_tab" >
          <div className="wp-row ">
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
          </div>
          <div className="wp-row ">
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
          </div>
          <div className="wp-row ">
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
            <Skeleton loading={isLoading} className={'wp-tiles skeleton'} />
          </div>
        </div>
      )
        :
        (
          <>
          <HomeContext.Provider value={contextValue}>
            {
              <MainSection workspaces={workspaces} />
            }
          </HomeContext.Provider>
          </>
        )}
    </>
  );
};

export default HomeBase;

